import { CUSTOMERS_PATH } from 'cpmCarparks/navigation';

module.exports = {
  path: CUSTOMERS_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/CarparkCustomers'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/routes/show/routes/customers/index.js